export default __webpack_public_path__ + "static/media/image6.05a12b2a.jpg";